(function () {
  var toggle = document.querySelector("[data-menu-toggle]");
  var nav = document.querySelector("[data-header-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-tabs]").forEach(function (root) {
    var buttons = root.querySelectorAll("[data-tab]");
    var panels = root.querySelectorAll("[data-tab-panel]");
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-tab");
        buttons.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === id); });
      });
    });
  });

  document.querySelectorAll("[data-gallery]").forEach(function (root) {
    var main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-thumb]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        if (main) main.src = btn.getAttribute("data-src");
      });
    });
  });

  function qtyForPlan(id) {
    return id === "two" ? "2" : "1";
  }

  function setPlanQty(root, id) {
    var scope = root.closest("section") || root;
    scope.querySelectorAll("form[action='/cart/add'] input[name='quantity']").forEach(function (input) {
      input.value = qtyForPlan(id);
    });
  }

  document.querySelectorAll("[data-plans]").forEach(function (root) {
    var selected = root.querySelector("[data-plan].is-on");
    if (selected) setPlanQty(root, selected.getAttribute("data-plan"));
    root.querySelectorAll("[data-plan-select]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-plan-select");
        root.querySelectorAll("[data-plan]").forEach(function (plan) {
          var on = plan.getAttribute("data-plan") === id;
          plan.classList.toggle("is-on", on);
          var dot = plan.querySelector(".radio-dot, .hp-radio");
          if (dot) dot.classList.toggle("is-on", on);
        });
        var onceBtn = root.querySelector("[data-plan-select='once']");
        if (onceBtn && onceBtn.tagName === "BUTTON") {
          onceBtn.classList.toggle("is-on", id === "once");
        }
        setPlanQty(root, id);
      });
    });
  });

  document.querySelectorAll("[data-label-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest("[data-label-card]");
      if (!card) return;
      var off = card.querySelector("[data-off]");
      var on = card.querySelector("[data-on]");
      if (!off || !on) return;
      var showing = !on.hasAttribute("hidden");
      if (showing) {
        on.setAttribute("hidden", "");
        off.removeAttribute("hidden");
        btn.textContent = "View label ↗";
      } else {
        off.setAttribute("hidden", "");
        on.removeAttribute("hidden");
        btn.textContent = "View product ↗";
      }
    });
  });

  document.querySelectorAll("[data-scents]").forEach(function (root) {
    var slides = [
      root.querySelector("[data-scent-go='0'] img") && root.querySelector("[data-scent-go='0'] img").src,
      root.querySelector("[data-scent-go='1'] img") && root.querySelector("[data-scent-go='1'] img").src,
      root.querySelector("[data-scent-go='2'] img") && root.querySelector("[data-scent-go='2'] img").src,
      root.querySelector("[data-scent-go='3'] img") && root.querySelector("[data-scent-go='3'] img").src
    ];
    var main = root.querySelector("[data-scent-main]");
    var alts = ["Cedar", "Mint", "Yuzu", "Basil"];
    function show(index) {
      if (!main || !slides[index]) return;
      main.src = slides[index];
      main.alt = alts[index];
      root.querySelectorAll("[data-scent-go]").forEach(function (el) {
        el.classList.toggle("is-on", el.getAttribute("data-scent-go") === String(index));
      });
    }
    root.querySelectorAll("[data-scent-go]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        show(btn.getAttribute("data-scent-go"));
      });
    });
  });

  document.querySelectorAll("[data-hair-slider]").forEach(function (root) {
    var track = root.querySelector("[data-hair-track]");
    var prev = root.querySelector("[data-hair-prev]");
    var next = root.querySelector("[data-hair-next]");
    if (!track || !prev || !next) return;
    var animating = false;

    function cardStep() {
      var card = track.querySelector(".hair-card");
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      if (animating || !track.children.length) return;
      var step = cardStep();
      if (!step) return;
      animating = true;
      if (dir > 0) {
        track.style.transition = "transform .45s ease";
        track.style.transform = "translateX(" + (-step) + "px)";
        track.addEventListener("transitionend", function done(e) {
          if (e.target !== track) return;
          track.removeEventListener("transitionend", done);
          track.style.transition = "none";
          track.appendChild(track.firstElementChild);
          track.style.transform = "translateX(0)";
          animating = false;
        });
      } else {
        track.style.transition = "none";
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = "translateX(" + (-step) + "px)";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.transition = "transform .45s ease";
            track.style.transform = "translateX(0)";
            track.addEventListener("transitionend", function done(e) {
              if (e.target !== track) return;
              track.removeEventListener("transitionend", done);
              animating = false;
            });
          });
        });
      }
    }

    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
  });

  document.querySelectorAll("[data-result-slider]").forEach(function (root) {
    var track = root.querySelector("[data-result-track]");
    var prev = root.querySelector("[data-result-prev]");
    var next = root.querySelector("[data-result-next]");
    if (!track || !prev || !next) return;
    var animating = false;

    function cardStep() {
      var card = track.querySelector(".result-card");
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      if (animating || !track.children.length) return;
      var step = cardStep();
      if (!step) return;
      animating = true;
      if (dir > 0) {
        track.style.transition = "transform .45s ease";
        track.style.transform = "translateX(" + (-step) + "px)";
        track.addEventListener("transitionend", function done(e) {
          if (e.target !== track) return;
          track.removeEventListener("transitionend", done);
          track.style.transition = "none";
          track.appendChild(track.firstElementChild);
          track.style.transform = "translateX(0)";
          animating = false;
        });
      } else {
        track.style.transition = "none";
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = "translateX(" + (-step) + "px)";
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.transition = "transform .45s ease";
            track.style.transform = "translateX(0)";
            track.addEventListener("transitionend", function done(e) {
              if (e.target !== track) return;
              track.removeEventListener("transitionend", done);
              animating = false;
            });
          });
        });
      }
    }

    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
  });

  document.querySelectorAll("[data-reviews]").forEach(function (root) {
    var extra = root.querySelectorAll("[data-review-extra]");
    var more = root.querySelector("[data-reviews-more]");
    if (more) {
      more.addEventListener("click", function () {
        extra.forEach(function (el) { el.removeAttribute("hidden"); });
        more.setAttribute("hidden", "");
      });
    }
    root.querySelectorAll("[data-read-more]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var body = btn.previousElementSibling;
        if (body) body.classList.add("is-open");
        btn.setAttribute("hidden", "");
      });
    });
  });

  function drawerEl() {
    return document.querySelector("[data-cart-drawer]");
  }

  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    if (Math.round(n * 100) % 100 === 0) return "$" + n.toFixed(0);
    return "$" + n.toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function syncCartCount(count) {
    var drawer = drawerEl();
    if (drawer) drawer.setAttribute("data-count", String(count));
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function openCart() {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });
    document.body.classList.add("cart-open");
  }

  function closeCart() {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("cart-open");
    window.setTimeout(function () {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 280);
  }

  function fallbackDiscountTitle(qty) {
    if (qty >= 3) return "Buy 3+ save 20%";
    if (qty === 2) return "Buy 2 save 10%";
    if (qty === 1) return "Buy 1 save 5%";
    return "Discount";
  }

  function cartFooterHtml(cart) {
    var goal = 5000;
    var now = cart.total_price || 0;
    var pct = Math.min(100, Math.round((now / goal) * 100));
    var shipText = now >= goal
      ? "Free shipping unlocked"
      : "Add " + formatMoney(goal - now) + " more for free shipping";
    var original = cart.original_total_price || cart.items_subtotal_price || cart.total_price;
    var discount = cart.total_discount || 0;
    var apps = cart.cart_level_discount_applications || [];
    var discountRows = "";
    if (apps.length) {
      apps.forEach(function (app) {
        discountRows +=
          '<p class="cart-discount"><span>' + escapeHtml(app.title) + "</span><strong>-" +
          formatMoney(app.total_allocated_amount || discount) + "</strong></p>";
      });
    } else if (discount > 0) {
      discountRows =
        '<p class="cart-discount"><span>' + escapeHtml(fallbackDiscountTitle(cart.item_count)) +
        "</span><strong>-" + formatMoney(discount) + "</strong></p>";
    }
    var tip = "";
    if (cart.item_count === 1) tip = '<p class="cart-deal">Add 1 more to save 10%</p>';
    else if (cart.item_count === 2) tip = '<p class="cart-deal">Add 1 more to save 20%</p>';
    return (
      '<footer class="cart-drawer-foot">' +
        '<div class="cart-ship-bar">' +
          '<p class="cart-ship">' + shipText + "</p>" +
          '<div class="cart-ship-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>' +
        "</div>" +
        '<p class="cart-subtotal"><span>Subtotal</span><strong>' + formatMoney(original) + "</strong></p>" +
        discountRows +
        (discount > 0 ? '<p class="cart-subtotal cart-total"><span>Total</span><strong>' + formatMoney(cart.total_price) + "</strong></p>" : "") +
        tip +
        '<a class="btn btn-coral full" href="/checkout">Checkout</a>' +
      "</footer>"
    );
  }

  function renderCart(cart, thenOpen) {
    var drawer = drawerEl();
    if (!drawer || !cart) return;
    var body = drawer.querySelector("[data-cart-body]");
    if (!body) return;
    syncCartCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a class="btn btn-coral" href="/products/flakes-1" data-cart-close>Shop now</a></div>';
    } else {
      var items = cart.items.map(function (item) {
        var img = item.image || (item.featured_image && (item.featured_image.url || item.featured_image.src)) || "";
        var price = formatMoney(item.final_line_price);
        if (item.original_line_price > item.final_line_price) {
          price = "<s>" + formatMoney(item.original_line_price) + "</s>" + price;
        }
        return (
          '<div class="cart-drawer-item">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '">' : "") +
            '<div class="cart-drawer-copy">' +
              "<strong>" + escapeHtml(item.product_title) + "</strong>" +
              '<button type="button" class="cart-remove" data-cart-remove="' + escapeHtml(item.key) + '">Remove</button>' +
              '<div class="cart-drawer-row">' +
                '<div class="cart-qty" data-cart-qty data-key="' + escapeHtml(item.key) + '">' +
                  '<button type="button" data-qty-minus aria-label="Decrease quantity">-</button>' +
                  '<input data-qty-input type="number" name="quantity" value="' + item.quantity + '" min="1" inputmode="numeric" aria-label="Quantity">' +
                  '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
                "</div>" +
                '<div class="cart-item-price">' + price + "</div>" +
              "</div>" +
            "</div>" +
          "</div>"
        );
      }).join("");
      body.innerHTML = '<div class="cart-drawer-list">' + items + "</div>" + cartFooterHtml(cart);
    }
    if (thenOpen) openCart();
  }

  function refreshCart(thenOpen) {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart, thenOpen); });
  }

  function changeCartQty(key, qty, keepOpen) {
    var nextQty = parseInt(qty, 10);
    if (isNaN(nextQty) || nextQty < 0) nextQty = 0;
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: nextQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart, keepOpen); });
  }

  function addToCartFromForm(form) {
    var scope = form.closest("section") || form.closest("[id^='shopify-section']") || document;
    var selected = scope.querySelector("[data-plan].is-on");
    var qtyInput = form.querySelector("input[name='quantity']");
    if (selected && qtyInput) qtyInput.value = qtyForPlan(selected.getAttribute("data-plan"));
    return fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
      .then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return refreshCart(true);
      })
      .then(function () { openCart(); });
  }

  document.addEventListener("click", function (e) {
    var cartLink = e.target.closest("[data-cart-open], a[href='/cart'], a[href$='/cart']");
    if (cartLink && !e.target.closest("[data-cart-drawer]")) {
      e.preventDefault();
      refreshCart(true);
      return;
    }
    if (e.target.closest("[data-cart-close]")) {
      if (e.target.closest("a[href]") && e.target.closest("a[href]").getAttribute("href") !== "#") {
        closeCart();
        return;
      }
      e.preventDefault();
      closeCart();
      return;
    }
    var remove = e.target.closest("[data-cart-remove]");
    if (remove) {
      e.preventDefault();
      changeCartQty(remove.getAttribute("data-cart-remove"), 0, true);
      return;
    }
    var wrap = e.target.closest("[data-cart-qty]");
    if (!wrap) return;
    var input = wrap.querySelector("[data-qty-input]");
    var key = wrap.getAttribute("data-key");
    if (!input || !key) return;
    var inDrawer = !!e.target.closest("[data-cart-drawer]");
    if (e.target.closest("[data-qty-minus]")) {
      changeCartQty(key, Math.max(0, parseInt(input.value, 10) - 1), inDrawer);
    } else if (e.target.closest("[data-qty-plus]")) {
      changeCartQty(key, parseInt(input.value, 10) + 1, inDrawer);
    }
  });

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    var wrap = input.closest("[data-cart-qty]");
    if (!wrap) return;
    changeCartQty(wrap.getAttribute("data-key"), input.value, !!input.closest("[data-cart-drawer]"));
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute("action") || "";
    if (action !== "/cart/add" && action.indexOf("/cart/add") === -1) return;
    e.preventDefault();
    addToCartFromForm(form);
  }, true);
})();
